export const PROFILE_VISIBLE_QUANTITY = 16;

export enum ViewType {
  LIST = 'list',
  GRID = 'grid',
}
